export function sliderEventsOnScroll() {
	const sliders = document.querySelectorAll(".ilawyer-slider");
	async function loadSlider(slider) {
		if (!slider.dataset.sliderInitialized) {
			try {
				const sliderModule = await import("./slider.js");
				await sliderModule.initSlider(slider);
				slider.dataset.sliderInitialized = true;
			} catch (err) {
				console.error("Failed to load module:", err);
			}
		}
	}
	sliders.forEach((slider) => {
		const slideObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						loadSlider(slider).then(() => {
							slideObserver.unobserve(entry.target);
						});
					}
				});
			},
			{
				rootMargin: "0px 0px 200px 0px",
				threshold: 0,
			}
		);
		slideObserver.observe(slider);
	});
}
